import React from 'react';
import { Collapse } from '@mui/material';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import HideButton from '../../../components/hide-button/HideButton';
import validate from '../../../utils/validate';
import ResponseFormInner from './ResponseFormInner';
import { responseYopValidation } from './validation';

import scss from './ResponseForm.module.scss';

function ResponseForm({ isShowResponseForm, toggleResponseFormVisibility, onSendResponse, onClickForHelp }) {
  const { t } = useTranslation('scout');

  const initialResponseFormValues = {
    company: '',
    email: '',
    market: '',
    respondentVolume: '',
    surveyTemplate: '',
    gender: '',
    ageFrom: null,
    ageTo: null,
    region: '',
    otherRequirements: '',
  };

  const handleSendResponse = async (values) => {
    await onSendResponse(values);
  };

  return (
    <div className={scss.responseSection}>
      <HideButton
        isShow={isShowResponseForm}
        onToggleVisibility={toggleResponseFormVisibility}
        label={t('fillRelevantInformation')}
        showLabelOpened
      />

      <Collapse in={isShowResponseForm}>
        <Form
          initialValues={initialResponseFormValues}
          onSubmit={handleSendResponse}
          subscription={{ submitting: true, pristine: true }}
          validate={(values) => validate(values, responseYopValidation())}
          render={({ handleSubmit }) => <ResponseFormInner onSubmit={handleSubmit} onClickForHelp={onClickForHelp} />}
        />
      </Collapse>
    </div>
  );
}

export default ResponseForm;
